import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function HomeSectionCreate() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await productService.getAllProducts();
      const productsArray = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      setProducts(productsArray);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      const payload = {
        name: formData.name,
        // sort_order: Number(formData.sort_order),
        status: Number(formData.status),
      products: formData.products.map((p) => p.id)  ,
      };

      await productService.createHomeSection(payload);

          Swal.fire({
        title: "Success",
        text: "Section Created successfully!",
        icon: "success",
        showConfirmButton: true,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn"
        },
        didOpen: () => {
          // Inject style dynamically if it doesn't exist
          if (!document.getElementById("swal-button-style")) {
            const style = document.createElement("style");
            style.id = "swal-button-style";
            style.innerHTML = `
              .swal-confirm-btn {
                background-color: var(--color-text-green) !important;
                color: #fff !important;
                border: none !important;
                border-radius: 4px !important;
                padding: 8px 20px !important;
                font-weight: bold !important;
              }
            `;
            document.head.appendChild(style);
          }
        }
      });

     navigate("/admin/home-section-products"); 
    } catch (err) {
      Swal.fire("Error!", err.message || "Something went wrong", "error");
    }
  };

 return (
  <DashboardWrapper>
    <div className="container mt-4">
     <Breadcrumb/>

      <div className="card shadow-sm">
        <div className="card-body">
          {/* <h4 className="card-title mb-4">Create Home Section</h4> */}

          <CrudForm
            initialData={{
              name: "",
              status: 1,
              products: [],
            }}
            onSubmit={handleSubmit}
            allowedFields={["name", "status", "products"]}
            customFields={{ products: { type: "multi-select" } }}
            products={products}
          />
        </div>
      </div>
    </div>
  </DashboardWrapper>
);
}